import { render, staticRenderFns } from "./evidence-list.vue?vue&type=template&id=ccc879c4&scoped=true&"
import script from "./evidence-list.vue?vue&type=script&lang=js&"
export * from "./evidence-list.vue?vue&type=script&lang=js&"
import style0 from "./evidence-list.vue?vue&type=style&index=0&id=ccc879c4&prod&lang=less&"
import style1 from "./evidence-list.vue?vue&type=style&index=1&id=ccc879c4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc879c4",
  null
  
)

export default component.exports